import React from 'react';
import { theme } from 'constants';

import { Text, I18nManager } from 'react-native';

const Icon = (name, rtl) => ({ color, size, style, selected, ...props }) => (
  <Text
    className={'ico-' + (rtl ? (I18nManager.isRTL ? rtl : name) : name) + (selected ? '2' : '')}
    style={[
      {
        color: color ? color : selected ? theme.primary_color : theme.gray_color_lighten(0.8),
        fontSize: size ? size : 32,
        textAlign: 'center'
      },
      style
    ]}
    {...props}
  />
);

export default Icon;

export const LoadAssets = () => 'N/A';



// WEBPACK FOOTER //
// ./src/utils/icons/icon.web.js